import React, { useState } from "react";
import "./DogodkiPodstrani.css";

const images = [
  { src: "/Slike/Dogodki/ObiskGuvernerja2025/slika1.webp", text: "Slika 1 ", alt: "" },
  { src: "/Slike/Dogodki/ObiskGuvernerja2025/slika2.webp", text: "Slika 2 ", alt: "" },
  { src: "/Slike/Dogodki/ObiskGuvernerja2025/slika3.webp", text: "Slika 3 ", alt: "" },
  { src: "/Slike/Dogodki/ObiskGuvernerja2025/slika4.webp", text: "Slika 4 ", alt: "" },
  { src: "/Slike/Dogodki/ObiskGuvernerja2025/slika5.webp", text: "Slika 5 ", alt: "" },
  { src: "/Slike/Dogodki/ObiskGuvernerja2025/slika6.webp", text: "Slika 6 ", alt: "" },
  { src: "/Slike/Dogodki/ObiskGuvernerja2025/slika7.webp", text: "Slika 7 ", alt: "" },
  { src: "/Slike/Dogodki/ObiskGuvernerja2025/slika8.webp", text: "Slika 8 ", alt: "" },
  { src: "/Slike/Dogodki/ObiskGuvernerja2025/slika9.webp", text: "Slika 9 ", alt: "" },
  { src: "/Slike/Dogodki/ObiskGuvernerja2025/slika10.webp", text: "Slika 10 ", alt: "" },
  { src: "/Slike/Dogodki/ObiskGuvernerja2025/slika11.webp", text: "Slika 11 ", alt: "" },
  { src: "/Slike/Dogodki/ObiskGuvernerja2025/slika12.webp", text: "Slika 12 ", alt: "" },
];

// videos used both in the page section and in the modal sequence
const videos = [
  {
    type: "video",
    src: "/Slike/Dogodki/ObiskGuvernerja2025/video1.mp4",
    text: "Video 1 – Govor guvernerja",
  },
  {
    type: "video",
    src: "/Slike/Dogodki/ObiskGuvernerja2025/video2.mp4",
    text: "Video 2 – Zahvala predsednika",
  },
];

const VIDEO_COUNT = videos.length;

// unified sequence for the modal: all images first, then videos
const media = [
  ...images.map((img) => ({ ...img, type: "image" })),
  ...videos,
];

const ObiskGuvernerja2025 = () => {
  const [currentIndex, setCurrentIndex] = useState(null); // index in `media`

  const handleImageClick = (index) => {
    setCurrentIndex(index); // images are first in `media`
  };

  const handleCloseModal = () => {
    setCurrentIndex(null);
  };

  const handleNext = () => {
    if (currentIndex === null) return;
    const nextIndex = (currentIndex + 1) % media.length;
    setCurrentIndex(nextIndex);
  };

  const handlePrev = () => {
    if (currentIndex === null) return;
    const prevIndex = (currentIndex - 1 + media.length) % media.length;
    setCurrentIndex(prevIndex);
  };

  const selected = currentIndex !== null ? media[currentIndex] : null;

  return (
    <div className="dogodkipodstranigallerycontainer">
      <h1 className="dogodkipodstranigallerytitle">
        Obisk guvernerja Matjaža Novaka, 24. 11. 2025
      </h1>
      <h3>( Galerija Slik )</h3>

      {/* IMAGE GALLERY */}
      <div className="dogodkipodstranigallery">
        {images.map((image, index) => (
          <div className="dogodkipodstranigalleryitem" key={image.src}>
            <img
              src={image.src}
              alt={image.alt}
              className="dogodkipodstranigalleryimage"
              loading={index < 4 ? "eager" : "lazy"}
              onClick={() => handleImageClick(index)}
            />
            <p className="dogodkipodstraniimagetext">{image.text}</p>
          </div>
        ))}
      </div>

      {/* VIDEO SECTION ON PAGE */}
      <div className="dogodkipodstranivideos">
        {videos.map((video) => (
          <div className="dogodkipodstranivideoitem" key={video.src}>
            <video
              controls
              preload="metadata"
              playsInline
              className="dogodkipodstranivideoplayer"
            >
              <source src={video.src} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            <p className="dogodkipodstranivideotext">{video.text}</p>
          </div>
        ))}
      </div>

      <br />
      <p style={{ color: "#17458f" }}>
        ( Število Fotografij : {images.length} / Število Videov : {VIDEO_COUNT} )
      </p>

      {/* MODAL: supports both images and videos in sequence */}
      {selected && (
        <div className="dogodkimodal" onClick={handleCloseModal}>
          <div
            key={currentIndex}
            className="dogodkimodalcontent"
            onClick={(e) => e.stopPropagation()}
          >
            <button className="dogodkiarrow-left" onClick={handlePrev}>
              &#8592;
            </button>

            {selected.type === "image" ? (
              <img
                key={selected.src}
                src={selected.src}
                alt={selected.alt || "Full-size event"}
                className="dogodkimodalimage"
              />
            ) : (
              <video
                key={selected.src}
                controls
                autoPlay
                playsInline
                className="dogodkimodalimage"
              >
                <source src={selected.src} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            )}

            <p className="dogodkimodaltext">{selected.text}</p>

            <button className="dogodkiclosebutton" onClick={handleCloseModal}>
              X
            </button>
            <button className="dogodkiarrow-right" onClick={handleNext}>
              &#8594;
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ObiskGuvernerja2025;
